<template>
  <v-container>
    <v-dialog
      width="100%"
      :value="isCropperOpen"
      @click="isCropperClose"
      @click:outside="isCropperClose"
    >
      <div class="content">
        <div class="show-info">
          <div class="vue-cropper-wrap">
            <vue-cropper
              ref="cropper"
              :src="imgSrc"
              :outputSize="option.size"
              :outputType="option.outputType"
              :autoCrop="option.autoCrop"
              :autoCropWidth="option.autoCropWidth"
              :autoCropHeight="option.autoCropHeight"
              :centerBox="option.centerBox"
              :fixedBox="option.fixedBox"
              :auto-crop-area="1"
              :aspect-ratio="1 / 1"
              :min-container-width="270"
              :min-container-height="270"
            ></vue-cropper>
          </div>
        </div>
      </div>
      <v-btn
        text
        @click="cropImage"
        class="triming"
      >トリミング</v-btn>
      <v-btn
        text
        @click="isCropperClose"
      >戻る</v-btn>
    </v-dialog>
  </v-container>
</template>
<script>
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

export default {
  components: {
    VueCropper,
  },
  data() {
    return {
      loading: false,
      model: 0,
      option: {
        size: 1,
        outputType: "png",
        autoCrop: true,
        autoCropWidth: 300,
        autoCropHeight: 300,
        centerBox: true,
        fixedBox: true,
      },
      beforCropImage: null,
    };
  },
  name: 'CropperModal',
  props: [
    'isCropperOpen',
    'isCropperClose',
    'imgSrc',
  ],
  methods: {
    cropImage() {
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
      this.$emit('sendImage', this.cropImg);
      this.isCropperClose();
    },
  },
}
</script>
<style>
* {
  margin: 0;
  padding: 0;
}
.content {
  padding: 30px 30px 30px 30px;
  background-color: white;
}
.show-info h2 {
  line-height: 50px;
}
.vue-cropper-wrap {
  min-height: 375px;
  max-height: 600px;
  text-align: center;
}
.cropper-drag-box {
  padding: "20px";
  min-width: "300px";
  text-align: center;
}
.triming {
  background-color: rgba(191, 41, 250, 0.905);
}
</style>